import { LoadingButton } from '@mui/lab';
import { Button, styled } from '@mui/material';

export const StyledRoundButton = styled(Button)({
  borderRadius: 100,
  width: '100%',
});

export const StyledRoundLoadingButton = styled(LoadingButton)({
  borderRadius: 100,
  width: '100%',
  height: 40,
});
